import React, { FC, memo } from 'react';
import { Line } from 'react-konva';

interface OriginCrosshairProps {
  canvasScale: number;
}

const GUIDE_EXTENT = 100000;

export const OriginCrosshair: FC<OriginCrosshairProps> = memo(({ canvasScale }) => {
  const strokeWidth = 1 / canvasScale;
  const dash = [10 / canvasScale, 4 / canvasScale, 2 / canvasScale, 4 / canvasScale];

  return (
    <>
      <Line points={[-GUIDE_EXTENT, 0, GUIDE_EXTENT, 0]} stroke="#1677ff" strokeWidth={strokeWidth} dash={dash} listening={false} />
      <Line points={[0, -GUIDE_EXTENT, 0, GUIDE_EXTENT]} stroke="#1677ff" strokeWidth={strokeWidth} dash={dash} listening={false} />
    </>
  );
});
